var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm._toggleSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h2', {
    staticStyle: {
      "display": "flex",
      "flex": "1"
    }
  }, [_vm._v("Footprint")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "href": "https://github.com/classLfz/",
      "target": "_blank"
    }
  }, [_c('md-icon', [_vm._v("account_circle")])], 1)], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "sidenav",
    staticClass: "md-left"
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', [_vm._v("Footprint")])])]), _vm._v(" "), _c('md-list', [_c('md-list-item', {
    attrs: {
      "href": "#/"
    },
    on: {
      "click": _vm._toggleSidenav
    }
  }, [_c('md-icon', [_vm._v("explore")]), _vm._v(" "), _c('span', [_vm._v("简介")])], 1), _vm._v(" "), _c('md-list-item', {
    attrs: {
      "href": "#/picture"
    },
    on: {
      "click": _vm._toggleSidenav
    }
  }, [_c('md-icon', [_vm._v("picture_in_picture")]), _vm._v(" "), _c('span', [_vm._v("看图")])], 1), _vm._v(" "), _c('md-list-item', {
    attrs: {
      "href": "#/saying"
    },
    on: {
      "click": _vm._toggleSidenav
    }
  }, [_c('md-icon', [_vm._v("record_voice_over")]), _vm._v(" "), _c('span', [_vm._v("说话")])], 1)], 1)], 1), _vm._v(" "), _c('router-view')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26a95da8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = /AhK
// module chunks = 1